import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CloseIcon(props: IconProps) {
    return <Icon {...props} iconKey={"close"}/>
}
